var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import InputFormik from '@src/components/Atoms/Formik/Input/InputFormik';
import { useParams } from 'react-router-dom';
var BlacklistForm = function (_a) {
    var useForm = _a.useForm, idForEdit = _a.idForEdit;
    var id = useParams().id;
    return (_jsx("div", __assign({ className: 'mb-3' }, { children: _jsx("div", { children: _jsx(InputFormik, { label: 'Alasan', type: 'text', placeholder: 'Alasan', name: 'note', formik: useForm }) }) })));
};
export default BlacklistForm;
